<template>
  <nav class="omnibar omnibar--fixed-top">
    <div class="container omnibar__container omnibar__container--full-width">
      <div class="omnibar__group-left">
        <div class="omnibar-logo__container">
          <a :href="omnibarLogo.link">
            <img
              class="omnibar-logo__image"
              src="https://webdist.data.apnic.net/web-framework-theme/9.1.5/images/apnic-reverse.svg"
              :alt="omnibarLogo.label_en_us"
            />
          </a>
        </div>
      </div>
      <div class="omnibar__group-right">
        <div class="dropdown">
          <button
            class="omnibar-hamburger__toggle omnibar-hamburger__toggle--desktop dropdown-toggle"
            id="omnibarHamburgerButton"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
            @click="onClickOutside">
            <img class="omnibar-hamburger__icon"
                 src="https://webdist.data.apnic.net/web-framework-theme/9.1.5/images/icon-square-kebab.svg"
                 aria-hidden="true"
                 alt=""
            />
          </button>
          <div
            class="dropdown-menu dropdown-menu-right omnibar-quick-links__wrap"
            aria-labelledby="omnibarHamburgerButton"
            style="display: none;">
            <a
              class="dropdown-item omnibar-quick-links__link"
              v-for="item of omnibarQuickLinks"
              :key="item.label_en_us"
              :href="item.link"
            >
              <span>{{ item.label_en_us }}</span>
            </a>
          </div>
        </div>
        <a
          class="omnibar-primary-action__button"
          @click="authenticateOidc"
          v-if="!oidcIsAuthenticated"
          style="cursor: pointer;">
          <span class="omnibar-primary-action__button-text">Log in</span>
        </a>

        <div v-click-outside="onClickOutside" class="dropdown" v-else>
          <button
            class="dropdown-toggle omnibar-current-user__toggle"
            id="omnibarCurrentUserButton"
            aria-haspopup="true"
            aria-expanded="false"
            @click="toggleUserMenu">
            <i
              class="fas fa-user-circle omnibar-current-user__toggle-icon"
              aria-hidden="true">
            </i>
          </button>
          <div
            class="dropdown-menu dropdown-menu-right omnibar-current-user__menu"
            aria-labelledby="omnibarCurrentUserButton"
            style="display: block;"
            v-if="showUserMenu">
            <div class="omnibar-current-user__hello">Hello, {{ username }}!</div>
            <hr class="omnibar-current-user__menu-hr" />
            <a
              class="dropdown-item omnibar-current-user__menu-link"
              v-for="item of omnibarCurrentUserAccountLinks"
              :key="item.label_en_us"
              :href="item.link"
            >
              <span>{{ item.label_en_us }}</span>
            </a>
            <hr class="omnibar-current-user__menu-hr" />
            <a
              class="dropdown-item omnibar-current-user__menu-link"
              v-for="item of omnibarCurrentUserMembershipLinks"
              :key="item.label_en_us"
              :href="item.link"
            >
              <span>{{ item.label_en_us }}</span>
            </a>
            <a
              class="dropdown-item omnibar-primary-action__button mt-2"
              @click="signOutOidc"
              :href="logout">
              <span class="omnibar-primary-action__button-text">Log out</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import { USER_MANAGEMENT_SERVICE } from "../../config/oidc";
import vClickOutside from "v-click-outside";

export default {
  directives: {
    clickOutside: vClickOutside.directive
  },
  data() {
    return { showUserMenu: false };
  },
  computed: {
    ...mapGetters("authStore", ["oidcIsAuthenticated", "oidcUser"]),
    // map this.{stateName} to store.state.{stateName}
    // see https://vuex.vuejs.org/guide/state.html#the-mapstate-helper
    ...mapState(["themeDataList"]),

    logout() {
      // Redirecting to single-logout to ensure other APNIC's applications are
      // logged off by invalidate all sessions.
      return `${USER_MANAGEMENT_SERVICE}/single-logout`;
    },

    username() {
      if (!this.oidcUser) {
        return "unknown user";
      }
      if (this.oidcUser.given_name) {
        return this.oidcUser.given_name;
      }
      if (this.oidcUser.family_name) {
        return this.oidcUser.family_name;
      }
      if (this.oidcUser.email) {
        return this.oidcUser.email;
      }
      return "guest";
    },

    omnibarQuickLinks() {
      return this.themeDataList.omnibarQuickLinks || [];
    },

    omnibarCurrentUserAccountLinks() {
      return this.themeDataList.omnibarCurrentUserAccountLinks || [];
    },

    omnibarCurrentUserMembershipLinks() {
      return this.themeDataList.omnibarCurrentUserMembershipLinks || [];
    },

    omnibarLogo() {
      return this.themeDataList.omnibarLogo || {};
    }
  },
  methods: {
    ...mapActions("authStore", ["signOutOidc", "authenticateOidc"]),

    toggleUserMenu() {
      this.showUserMenu = !this.showUserMenu;
    },

    onClickOutside() {
      this.showUserMenu = false;
    }
  }
};
</script>

<style scoped>
</style>
